// PayOrderBak.tsx
import PayOrderBase from './PayOrderBase';
import PayOrderBakEdit from './PayOrderBakEdit';
import WxPayOrderBakEdit from './wxPay/WxPayOrderBakEdit';
import WxPayRefundOrderBak from './wxPay/WxPayRefundOrderBak';

const PayOrderBak = (props: any) => (
    <PayOrderBase
        apiId="payOrderBak"
        wxPayOrderApiId="wxPayOrderBak"   // 若后端没有这个 apiId，可去掉，用默认 'wxPayOrder'
        titleName="支付订单(备份)"
        PayOrderEditComponent={PayOrderBakEdit}
        WxPayOrderEditComponent={WxPayOrderBakEdit}
        WxPayRefundOrderComponent={WxPayRefundOrderBak}
        outerProps={props}
    />
);

export default PayOrderBak;